import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {IRouterValidateProps} from '@/types';
import {PageRoute, STORAGE_KEYS} from '@/constants';

const ValidateLogin = ({children}: IRouterValidateProps) => {
  const location = useLocation();

  const isAuthenticated = !!localStorage.getItem(STORAGE_KEYS.USER_ACCESS_TOKEN);
  if (isAuthenticated) {
    return <Navigate to={PageRoute.HOME} state={{from: location}} />;
  } else if (children) {
    return <>{children}</>;
  } else {
    return <Outlet />;
  }
};

export default ValidateLogin;
